import React, { useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import HeaderPartner from "../HeaderPartner";
import { toast } from "react-toastify";
import axios from "axios";
import { Partner_Portal, partnerPortal_Url } from "../../Configuration/API_URL";
import SmallLoader from "../../Components/Common/smallLoader";
import { useEffect } from "react";
import thumbIcon from "../../asset/images/partner-portal/thumbs.svg";
import { Link, useNavigate } from "react-router-dom";
import { decryptData, encryptData } from "../../CommonMethods/CommonMethods";
import PageSideBar from "../PageSideBar";
import Loader from "../../Components/Common/Loader";

const EsignPagePartner = () => {
  const partnerToken = localStorage.getItem("partner_signup_token");
  // const loginToken = localStorage.getItem("Partner_Login_Token");
  const checkStage = localStorage.getItem("resumeDetails");
  const statusId = localStorage.getItem("statusId");
  const mobile = localStorage.getItem("Mobile");
  const [loader, setLoader] = useState(false);
  const [esignLoader, setEsignLoader] = useState(false);
  const navigate = useNavigate("");
  const [modalShow, setModalShow] = useState(false);
  const [esignDone, setEsignDone] = useState(false);
  const [finalLoader, setFinalLoader] = useState(false);

  if (partnerToken == null) {
    window.location.replace("/partner");
  }

  const getEsignDetails = async () => {
    setEsignLoader(true);
    try {
      const getValues = await axios.get(
        Partner_Portal.GetEsign_Url,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const esignResp = decryptData(getValues?.data);
      const decryptedEsign = JSON.parse(esignResp);
      if (decryptedEsign?.status === 0) {
        const didValue = decryptedEsign?.data?.info?.access_token?.entity_id;
        const docToken = decryptedEsign?.data?.info?.access_token?.id;
        if (
          (didValue !== undefined || null || "") &&
          (docToken !== undefined || null || "") &&
          (mobile !== undefined || null || "")
        ) {
          window.location.replace(
            Partner_Portal.ESIGNID +
              "&esign_identifier=" +
              mobile +
              "&docid=" +
              didValue +
              "&TokanId=" +
              docToken
          );
        } else {
          toast.error(
            "We are facing issue getting required parameters, Please try after sometime"
          );
        }
      } else if (decryptedEsign?.status === 1) {
        toast.error(decryptedEsign?.message);
      }
    } catch (error) {
      console.log(error);
      if(error?.response?.status === 500){
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if(error?.request?.status === 401){
        localStorage.clear("");
        navigate("/partner");
      }
    } finally {
      setEsignLoader(false);
    }
  };

  const getUrl = window.location.search;
  const urlParam = new URLSearchParams(getUrl);
  const orderStatus = urlParam.get("order_status");
  const statusMessage = urlParam.get("status_message");

  // const urlData = window.location.search?.split("order_status=");
  // const storeResp = urlData[1]?.split("&");
  // const getStatus=storeResp[0];
  // const getStatusMessage = storeResp[1]?.split("status_message=");
  // const failedMessage = getStatusMessage[1];

  const handleEsignData = () => {
    if (mobile !== null || undefined || "") {
      // if (
      //   orderStatus === "Success" ||
      //   JSON.parse(checkStage)?.paymentComplete === true
      // ) {
      getEsignDetails();
      // } else {
      //   window.location.replace(
      //     partnerPortal_Url +
      //       "/payment/ccavenue?redirectUrl=" +
      //       Partner_Portal.PAYMENT_ESIGN +
      //       "&mobile=" +
      //       mobile
      //   );
      // }
    } else {
      toast.error(
        "We are facing issue getting required parameters, Please try after sometime"
      );
    }
  };

  useEffect(() => {
    if (orderStatus !== "Success") {
      toast.error(statusMessage);
    }
  }, []);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  // Get the values of status and kid parameters
  const status = urlParams.get("status");
  const docid = urlParams.get("docid");

  console.log("Status:", status);
  console.log("docid:", docid);

  const downloadEsignData = async () => {
    let encryptedPayload = {
      docId: docid,
    };
    let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));
    try {
      const getValues = await axios.post(
        Partner_Portal.GetEsign_Url,
        encPayloadVal,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const esignData = decryptData(getValues?.data);
      const decryptedDownloadData = JSON.parse(esignData);
      if (decryptedDownloadData?.status === 0) {
        setEsignDone(true);
        updateApiSubmit();
      } else if (decryptedDownloadData?.status === 1) {
        toast.error(decryptedDownloadData?.message);
      }
    } catch (error) {
      console.log(error);
            if(error?.response?.status === 500){
              toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
            }
            if(error?.request?.status === 401){
              localStorage.clear("");
              navigate("/partner");
            }
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (status == 1 && docid !== null) {
      downloadEsignData();
    }
  }, []);


  const updateApiSubmit = async () => {
    setFinalLoader(true);
    let encryptedPayload = {
      statusId: 3,
    };
    let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));
    try {
      const getValues = await axios.put(
        Partner_Portal.CreatePartner_Url,
        encPayloadVal,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const updatedResp = decryptData(getValues?.data);
      const decryptUpdateResp = JSON.parse(updatedResp);
      if (decryptUpdateResp?.status === 0) {
        setModalShow(true);
      } else if (decryptUpdateResp?.status === 1) {
        toast.error(decryptUpdateResp?.message);
      }
    } catch (error) {
      console.log(error);
            if(error?.response?.status === 500){
              toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
            }
            if(error?.request?.status === 401){
              localStorage.clear("");
              navigate("/partner");
            }
    } finally {
      setFinalLoader(false);
    }
  };

  const handleLoginBtn = () => {
    window.location.replace("/partner");
  };

  return (
    <>
      <HeaderPartner />

      <main className="main-content page-wrapper partner-page esign-partner">
        {finalLoader === true && (
          <div className="final-loader-wrapper">
          <div className="final-loader">
            <Loader />
          </div>
          </div>
        )}

        <div className="h-md-100 ">
          <Row className="h-md-100 p-0 m-0 mobile-view">
            <Col lg={6} className="p-0">
              <PageSideBar />
            </Col>
            <Col lg={6} className="p-0">
              <div className="page-header right-box">
                <div className="payment-content-wrapper">
                  <div className="page-left landing-page viewheight">
                    {/* {JSON.parse(checkStage)?.paymentComplete === false &&
                    JSON.parse(checkStage)?.esignAgrtGenerated === false &&
                    JSON.parse(checkStage)?.esignAgrtDownload === false && orderStatus !== "Success" 
                    && esignDone === false ? ( */}
                    <div>
                      <p className="page-title text-capitalize">Make payment</p>
                      <p className="page-subtitle partner-subtitle">
                        This is the only payment we will take. It is for stamp
                        paper to execute partnership agreement
                      </p>
                    </div>
                    {/* ) : (
                      <div className="disable-content-text">
                        <p className="page-title text-capitalize">
                          Make payment
                        </p>
                        <p className="page-subtitle partner-subtitle">
                          This is the only payment we will take. It is for stamp
                          paper to execute partnership agreement
                        </p>
                      </div>
                    )} */}
                  </div>

                  <div
                    className="page-form landing-form esign-page"
                    autoComplete="off"
                    // onSubmit={handleEsignData}
                  >
                    <div className="row bank-detail-content">
                      {/* {JSON.parse(checkStage)?.paymentComplete === false &&
                      JSON.parse(checkStage)?.esignAgrtGenerated === false &&
                      JSON.parse(checkStage)?.esignAgrtDownload === false && orderStatus !== "Success"
                      && esignDone === false ? ( */}
                      <p className="esign-text">
                        Just pay Rs. 1000 towards stamp paper charges to execute
                        the partnership agreement between us. This agreement
                        will make it official that you are our Referral Partner
                        and can be carried as a proof of our partnership. 
                      </p>
                      {/* ) : (
                        <p className="esign-text blur-text">
                          Just pay Rs. 600 towards stamp paper charges to
                          execute the partnership agreement between us. This
                          agreement will make it official that you are our
                          Referral Partner and can be carried as a proof of our
                          partnership. 
                        </p>
                      )} */}
                    </div>

                    <div className="button-submit esign-btn">
                      {/* {JSON.parse(checkStage)?.paymentComplete === false &&
                      JSON.parse(checkStage)?.esignAgrtGenerated === false &&
                      JSON.parse(checkStage)?.esignAgrtDownload === false && 
                      orderStatus !== "Success" && esignDone === false ? ( */}
                      <button
                        type="submit"
                        className="partner-loginBtn esign-submit-btn disable-esign-btn"
                        disabled
                        onClick={handleEsignData}
                      >
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <div className="wrap-btn-text">
                            <p>FREE*</p>
                            <p className="pay-text">PAY ₹1000</p>
                          </div>
                        )}
                      </button>
                      {/* ) : (
                        <button
                          type="submit"
                          className="partner-loginBtn esign-submit-btn disable-esign-btn"
                          disabled
                          // onClick={handleEsignData}
                        >
                           <>COMPLETED</>
                        </button>
                      )} */}
                    </div>
                  </div>
                </div>

                <div className="payment-content-wrapper">
                  <div className="page-left landing-page viewheight">
                    {/* {orderStatus === "Success" ||
                    (JSON.parse(checkStage)?.paymentComplete === true &&
                      JSON.parse(checkStage)?.esignAgrtDownload === false)|| docid !== null ? ( */}
                    <div>
                      <p className="page-title text-capitalize">
                        E-Sign your agreement
                      </p>
                      <p className="page-subtitle partner-subtitle">
                        The agreement executed will make you an official partner
                        of Bajaj Broking
                      </p>
                    </div>
                    {/* ) : (
                      <div className="disable-content-text">
                        <p className="page-title text-capitalize">
                          E-Sign your agreement
                        </p>
                        <p className="page-subtitle partner-subtitle">
                          The agreement executed will make you an official
                          partner of Bajaj Broking
                        </p>
                      </div>
                    )} */}
                  </div>

                  <div
                    className="page-form landing-form"
                    autoComplete="off"
                    // onSubmit={handleEsignData}
                  >
                    {/* {orderStatus === "Success" ||
                    (JSON.parse(checkStage)?.paymentComplete === true &&
                      JSON.parse(checkStage)?.esignAgrtDownload === false) || docid !== null ? ( */}
                    <div className="row bank-detail-content">
                      <p className="esign-text">
                        Thank you for the payment of agreement stamp paper
                        charges. You can now proceed to e-sign the application
                        using Aadhaar Number.
                      </p>
                    </div>
                    {/* ) : (
                      <div className="row bank-detail-content blur-text">
                        <p className="esign-text">
                          Thank you for the payment of agreement stamp paper
                          charges. You can now proceed to e-sign the application
                          using Aadhaar Number.
                        </p>
                      </div>
                    )} */}

                    <div className="button-submit esign-btn esign-btn-main">
                      {/* {orderStatus === "Success" ||
                      (JSON.parse(checkStage)?.paymentComplete === true &&
                        JSON.parse(checkStage)?.esignAgrtDownload === false) || docid !== null ? ( */}
                      <button
                        type="submit"
                        className="partner-loginBtn esign-submit-btn"
                        onClick={handleEsignData}
                      >
                        {esignLoader ? <SmallLoader /> : <>PROCEED TO E-SIGN</>}
                      </button>
                      {/* ) : (
                        <button
                          type="submit"
                          disabled
                          className="partner-loginBtn esign-submit-btn disable-esign-btn"
                        >
                          <>PROCEED TO E-SIGN</>
                        </button>
                      )} */}
                    </div>
                  </div>
                </div>

                <div className="payment-progress-wrapper">
                  <ul className="payment-progress">
                    {/* {JSON.parse(checkStage)?.paymentComplete === true ?} */}
                    <li
                      className={
                        `success`
                        // JSON.parse(checkStage)?.paymentComplete === true || orderStatus === "Success" || docid !== null
                        // || JSON.parse(checkStage)?.esignAgrtDownload === true
                        //   ? `success`
                        //   : `active`
                      }
                    ></li>
                    <span
                      className={
                        `success-dot`
                        // JSON.parse(checkStage)?.paymentComplete === true || orderStatus === "Success" || docid !== null
                        // || JSON.parse(checkStage)?.esignAgrtDownload === true
                        //   ? `success-dot`
                        //   : `active`
                      }
                    ></span>

                    <li
                      className={
                        `active`
                        // JSON.parse(checkStage)?.paymentComplete === true || orderStatus === "Success"
                        // || docid !== null || JSON.parse(checkStage)?.esignAgrtDownload === true
                        //   ? `active`
                        //   : ``
                      }
                    ></li>
                    <span
                      className={
                        `active`
                        // JSON.parse(checkStage)?.paymentComplete === true || orderStatus === "Success" || docid !== null
                        // || JSON.parse(checkStage)?.esignAgrtDownload === true
                        //   ? `active`
                        //   : ``
                      }
                    ></span>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </main>

      <div className="congo-modal">
        <Modal
          show={modalShow}
          // onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="ifscModal confirmation-modal"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <img className="thumb-img" src={thumbIcon} alt="thumb icon" />
            <form className="modal-form select-new">
              <div className="form-group ">
                <label htmlFor="bank-text" className="modal-heading">
                  Congratulations!
                </label>
                <span>
                  Well done! Your registration completed successfully. You can
                  login to your account and explore the dashboard!
                </span>

                <button
                  type="button"
                  className="partner-loginBtn modal-login"
                  onClick={() => handleLoginBtn()}
                >
                  LOGIN
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};
export default EsignPagePartner;
